import { BASE_URL } from '#app/utils/config.ts'
import { createRoute } from './utils'

const publicRoutes = {
	base: createRoute('/', {
		id: 'base',
	}),

	about: createRoute('/what-is-sapienstone', {
		id: 'what-is-sapienstone',
		localize: true,
	}),

	contact: createRoute('/contact', {
		id: 'contact',
	}),

	products: {
		list: createRoute('/products', {
			id: 'products',
			localize: true,
		}),

		view: createRoute('/products/:slug', {
			id: 'product',
			localize: true,
		}),
	},

	landings: {
		dressYourLook: createRoute('/dress-code', {
			id: 'dressYourLook',
			localize: true,
		}),

		fourthDimension: createRoute('/4d-ceramics', {
			id: '4d-ceramics',
			localize: true,
		}),

		design: createRoute('/design', {
			id: 'design',
			localize: true,
		}),

		innovation: createRoute('/innovation-and-quality', {
			id: 'innovation-and-quality',
			localize: true,
		}),

		sustainability: createRoute('/sustainability', {
			id: 'sustainability',
			localize: true,
		}),
	},

	product: createRoute('/products/:slug', {
		id: 'product',
		localize: true,
	}),

	legal: {
		cookies: {
			es: 'https://www.iubenda.com/privacy-policy/71002568/cookie-policy',
			en: 'https://www.iubenda.com/privacy-policy/51811594/cookie-policy',
			fr: 'https://www.iubenda.com/privacy-policy/35134173/cookie-policy',
			it: 'https://www.iubenda.com/privacy-policy/92378897/cookie-policy',
			de: 'https://www.iubenda.com/privacy-policy/14062984/cookie-policy',
		},

		privacy: createRoute('/privacy-policy', {
			id: 'privacy',
			localize: true,
		}),
	},

	auth: {
		login: createRoute('/login', {
			id: 'login',
			localize: true,
		}),
		resetPassword: createRoute('/reset-password', {
			id: 'reset-password',
			localize: true,
		}),
		forgotPassword: createRoute('/forgot-password', {
			id: 'forgotPassword',
			localize: true,
		}),
		signup: createRoute('/signup', {
			id: 'signup',
			localize: true,
		}),
		onboarding: createRoute('/onboarding', {
			id: 'onboarding',
			localize: true,
		}),
		verify: createRoute('/verify', {
			id: 'verify',
			localize: true,
		}),
	},

	blog: {
		index: createRoute('/magazine', {
			id: 'blog',
			localize: true,
		}),
		post: createRoute('/magazine/:slug', {
			id: 'blogPost',
			localize: true,
		}),
	},

	professional: createRoute('/professional', {
		id: 'professional',
		localize: true,
	}),

	downloads: createRoute('/downloads', {
		id: 'downloads',
		localize: true,
	}),

	search: createRoute('/search', {
		id: 'search',
		localize: true,
	}),

	document: createRoute('/resources/doc/:document', {
		id: 'document',
		localize: true,
	}),

	social: {
		fbShare: (link: string) =>
			`https://www.facebook.com/sharer/sharer.php?u=${link.startsWith('https') || link.startsWith('www.') ? link : `${BASE_URL}${link.startsWith('/') ? '' : '/'}${link}`}`,
		inShare: (link: string) =>
			`https://www.linkedin.com/cws/share?url=${link.startsWith('https') || link.startsWith('www.') ? link : `${BASE_URL}${link.startsWith('/') ? '' : '/'}${link}`}`,
		pinShare: (link: string, media: string, title: string) =>
			`https://pinterest.com/pin/create/bookmarklet/?media=${media}&url=${link.startsWith('https') || link.startsWith('www.') ? link : `${BASE_URL}${link.startsWith('/') ? '' : '/'}${link}`}&is_video=false&description=${title}`,
	},
}

export default publicRoutes
